import { IAgendaWelcomeRepository } from 'modules/customer/domain/repositories';
import { makeHTTPProvider } from 'shared/infra/providers';

import VectisAgendaWelcomeRepository from './implementations/VectisAgendaWelcomeRepository';

let instance: IAgendaWelcomeRepository | null = null;

export default function makeAgendaWelcomeRepository() {
  if (!instance) {
    const httpProvider = makeHTTPProvider();

    instance = new VectisAgendaWelcomeRepository(httpProvider);
  }

  return instance;
}
